import React, { createContext, useContext } from 'react';
import usePostApprovalPlaid from './usePostApprovalPlaid';

const PostApprovalPlaidContext = createContext(null);

export const PostApprovalPlaidProvider = ({ children }) => {
  const plaid = usePostApprovalPlaid();

  return (
    <PostApprovalPlaidContext.Provider
      value={{ ...plaid, contextManaged: true }}
    >
      {children}
    </PostApprovalPlaidContext.Provider>
  );
};

const usePostApprovalPlaidContext = () => {
  const sharedPlaid = useContext(PostApprovalPlaidContext);
  const standalonePlaid = usePostApprovalPlaid({ active: !sharedPlaid });

  return sharedPlaid || { ...standalonePlaid, contextManaged: false };
};

export default usePostApprovalPlaidContext;
